import { evaluate } from 'mathjs';

const interestRate = 0.05; // yearly interest rate
const i = interestRate / 12; // interest rate per month
const n = 30 * 12; // 360 payments over 30 yrs

export const getMortgageCost = (homePrice: number) => {
  const mortgage = evaluate(
    `${homePrice} * [ ${i} * (1 + ${i})^${n} ] / [ (1 + ${i})^${n} - 1]`
  );

  return mortgage;
};
